import { render, staticRenderFns } from "./RootNotifications.vue?vue&type=template&id=ea295dee&scoped=true&"
import script from "./RootNotifications.vue?vue&type=script&lang=js&"
export * from "./RootNotifications.vue?vue&type=script&lang=js&"
import style0 from "./RootNotifications.vue?vue&type=style&index=0&id=ea295dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea295dee",
  null
  
)

export default component.exports